import { Box } from '@mui/material'
import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AboutusImage from '../../assets/images/AboutusImage.webp'

const AboutBgLanding = () => {
  return (
    <Box sx={{
        width:"100%",
        paddingTop:{xs: '6rem',sm:'5rem'},
    }} >
    <Box sx={{
        
    }} >
    <LazyLoadImage
          src={AboutusImage}
          effect="blur"
          width="100%"
          height="100%"
        />
    </Box>
    </Box>
  )
}

export default AboutBgLanding
